import sendRequest from 'utils/sendRequest'
import { ILoginExternalWallet } from './type'
import { AxiosResponse } from 'axios'

const URL = process.env.REACT_APP_API_BACKEND_URL + '/admin/'

export async function loginExternalWallet({
  signature,
  address,
}: {
  signature?: string
  address?: string
}): Promise<AxiosResponse<ILoginExternalWallet> | undefined> {
  if (!address || !signature) return undefined

  const data = { signature, address }
  return sendRequest(
    {
      url: URL + 'login-external-wallet',
      method: 'POST',
      data,
    },
    true
  )
}
